import Vue from "vue";
import Router from "vue-router";
import acquisti from "./components/acquisti/_routes";
import articoli from "./components/articoli/_routes";
import attrezzature from "./components/attrezzature/_routes";
import avanzamenti from "./components/avanzamenti/_routes";
import pianificazione from "./components/pianificazione/_routes";
import consoleRoutes from "./components/console/_routes";
import notificationRoutes from "./components/notifications/_routes";
import files from "./components/files/_routes";
import documentale from "./components/documentale/_routes";
import teamLeader from "./components/team-leader/_routes";

import dashboard from "./components/dashboard/_routes";
import fornitore from "./components/fornitore/_routes";
import hr from "./components/hr/_routes";
import laser from "./components/laser/_routes";
import magazzino from "./components/magazzino/_routes";
import milkrun from "./components/milkrun/_routes";
import ordini from "./components/ordini/_routes";
import qualita from "./components/qualita/_routes";
import segnalazioni from "./components/segnalazioni/_routes";
import spooler from "./components/spooler/_routes";
import staff from "./components/staff/_routes";
import controlloGestione from "./components/controllo-gestione/_routes";
import tempi from "./components/tempi/_routes";
import store from "./store";
import { workMenu } from "./accessMenu";
import { bindAccessCatalog, buildAccessCatalog } from "./utils/accessCatalog.mjs";
import { configureAccessCatalog, ensureCapabilities } from "./utils/accessControl.mjs";
import { resetIdentity } from "./utils/impersonation.mjs";
import { pageDiagnostics } from "./utils/pageDiagnostics.mjs";
import { routePattern } from "./utils/diagnosticsEvents.mjs";

const DashHome = () => import("./components/DashHome");
const NotFound = () => import("./components/NotFound");
const Login = () => import("./components/Login");
const Search = () => import("./components/Search");

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

// Stesso trattamento per replace: navigazioni annullate/duplicate non sono errori (WORK-FRONTEND-GP).
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch((err) => err);
};

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isLoggedIn) {
        return next();
    }

    return next("/");
};

const ifAuthenticated = async (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next();
    } else {
        next("/login");
    }
};

Vue.use(Router);

const routes = [
    {
        path: "/anagrafiche/:code?",
        name: "Anagrafiche",
        component: () => import("./components/anagrafiche/Anagrafiche.vue"),
        beforeEnter: ifAuthenticated,
        meta: { menu: "anagrafiche", title: "Anagrafiche" },
    },
    {
        path: "/diagnostica-pagine",
        name: "DiagnosticaPagine",
        component: () => import("./components/diagnostics/PageDiagnostics.vue"),
        beforeEnter: ifAuthenticated,
        meta: { title: "Diagnostica pagine" },
    },
    {
        path: "/impersonate-login",
        name: "ImpersonateLogin",
        component: () => import("./components/ImpersonateLogin.vue"),
        beforeEnter: (to, from, next) => {
            resetIdentity(store);
            next();
        },
        meta: { title: "Accesso come utente", publicAuth: true },
    },
    ...dashboard,
    ...teamLeader,
    ...files,
    ...documentale,
    ...avanzamenti,
    ...pianificazione,
    ...laser,
    ...articoli,
    ...ordini,
    ...staff,
    ...controlloGestione,
    ...consoleRoutes,
    ...notificationRoutes,

    ...tempi,
    ...milkrun,
    ...magazzino,
    ...qualita,
    ...segnalazioni,
    ...acquisti,
    ...fornitore,
    ...hr,
    ...spooler,
    ...attrezzature,

    {
        path: "/",
        name: "Home",
        component: DashHome,
        beforeEnter: ifAuthenticated,
        meta: { title: "Home" },
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        beforeEnter: ifNotAuthenticated,
        meta: { title: "Login" },
    },
    {
        path: "/search/:query?",
        name: "Search",
        component: Search,
        meta: { title: "Search" },
    },
    { path: "*", component: NotFound },
];
const accessCatalog = buildAccessCatalog(routes, workMenu);
bindAccessCatalog(routes, workMenu, accessCatalog);
configureAccessCatalog(accessCatalog.items);

const router = new Router({ routes, mode: "history" });
router.beforeEach(async (to, from, next) => {
    try { pageDiagnostics.startNavigation(routePattern(to), from.matched.length ? "route_enter" : "reload"); } catch (_) { /* Measurement must not prevent navigation. */ }
    const capability = to.meta?.accessCapability;
    if (!capability || !store.getters.isLoggedIn) return next();
    // Cost reports display the API's permission failure without exposing data.
    if (to.meta?.apiAccessFeedback) return next();
    try {
        await ensureCapabilities(store, window.work_api);
    } catch (error) {
        console.warn("Controllo accesso pagina non disponibile", error);
        return next();
    }
    if (!store.getters.isCapabilityDefined(capability)) return next();
    if (store.getters.hasCapability(capability)) return next();
    return to.path === "/" ? next(false) : next("/");
});
router.afterEach(() => { pageDiagnostics.milestone("route_enter"); });
router.onError(() => { try { pageDiagnostics.navigation.leave("error"); } catch (_) { /* Navigation retains its original error. */ } });

export default router;
